import * as React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import * as actions from '../../../../../redux/testMode/actions.testMode';
import asyncDispatch from '../../../../../services/mini/asyncDispatch';
import ConfirmPopup from '../../../../components/ConfirmPopup/ConfirmPopup';
import getConversationId from '../../../../../services/mini/getConversationId';
import { IRefreshAllDialogsParam } from '../../../../../redux/testMode/actions.testMode';
import { confirmAlert } from '../../../../../services/mini/alanConfirmAlert';

type RunAllButtonProps = PropsFromRedux;

class RunAllButton extends React.Component<RunAllButtonProps> {

    runAll = () => {
        const {
            runAllDialogs,
            stopRunningDialogs,
            stopDialog,
            stopRefreshPhrases,
            isDialogsRefreshingInProcess,
            isOneDialogRefreshingInProcess,
            refreshingIsInProcess
        } = this.props;

        if (isDialogsRefreshingInProcess || isOneDialogRefreshingInProcess || refreshingIsInProcess) {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <ConfirmPopup
                            onClose={onClose}
                            okBtnLabel="Stop"
                            okBtnCb={() => {
                                onClose();
                                if (isDialogsRefreshingInProcess) {
                                    stopRunningDialogs();
                                }
                                if (isOneDialogRefreshingInProcess) {
                                    stopDialog();
                                }
                                if (refreshingIsInProcess) {
                                    stopRefreshPhrases();
                                }
                            }}
                            title="Stop running dialog(s)"
                            message={<div>Are you sure you want to stop current run of the existing dialog(s)?</div>}
                        />
                    );
                }
            });
        } else {
            runAllDialogs({});
        }
    }

    render() {
        const {
            isDialogsRefreshingInProcess,
            isOneDialogRefreshingInProcess,
            refreshingIsInProcess
        } = this.props;

        return (
            <div
                className={`run-all-btn action-btn dark-with-blue-border middle width-100p ${(isDialogsRefreshingInProcess) && 'refreshing'}`}
                onClick={this.runAll}>
                <div className="run-all-btn_content">
                    {(isDialogsRefreshingInProcess || isOneDialogRefreshingInProcess || refreshingIsInProcess) ?
                        <>
                            <i className="icon icon-alan-stop-intent" />Stop
                        </> :
                        <>
                            <i className="icon icon-alan-triangle-right" />Run All
                        </>}
                </div>
            </div>
        );
    }
}


function mapStateToProps({ testMode, projectsInfo }) {
    return {
        dialogTree: testMode.dialogTree,
        refreshingDialogs: testMode.refreshingDialogs, // todo: rename props below in reducer, because this is actually:
        refreshingIsInProcess: testMode.refreshingIsInProcess,// run one dilog 
        isDialogsRefreshingInProcess: testMode.isDialogsRefreshingInProcess,// run all converation
        isOneDialogRefreshingInProcess: testMode.isOneDialogRefreshingInProcess,// run converation
        conversationId: getConversationId(projectsInfo.currentProject.conversations)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        runAllDialogs: (param: IRefreshAllDialogsParam) => asyncDispatch(actions.runAllDialogs, dispatch, param),
        stopRunningDialogs: () => asyncDispatch(actions.stopRunningDialogs, dispatch),
        stopDialog: () => asyncDispatch(actions.stopDialog, dispatch),
        stopRefreshPhrases: () => asyncDispatch(actions.stopRefreshPhrases, dispatch),
    };
}


const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(RunAllButton);